import { NO_START, NO_END, dateToTimestamp } from '@ha/date';

import { FilterBuilder } from '../Types';
import { MULTIUSE_START, MULTIUSE_END } from '../constants';

const dateFromFilter = (startDate: string) => {
  const startDateTS = dateToTimestamp(new Date(startDate));
  const noStartDateTS = dateToTimestamp(new Date(NO_START));
  const multiuseStartDateTS = dateToTimestamp(new Date(MULTIUSE_START));

  return `(dateFromTS<=${startDateTS} OR dateFromTS=${noStartDateTS} OR dateFromTS=${multiuseStartDateTS})`;
};

const dateToFilter = (startDate: string, endDate?: string) => {
  const noEndDateTS = dateToTimestamp(new Date(NO_END));
  const multiuseEndDateTS = dateToTimestamp(new Date(MULTIUSE_END));

  // if end date is specified then use that, otherwise use the startDate
  const endDateTS = dateToTimestamp(new Date(endDate || startDate));

  return `(dateToTS>=${endDateTS} OR dateToTS=${noEndDateTS} OR dateToTS=${multiuseEndDateTS})`;
};

const dateTSBuilder: FilterBuilder = ({ startDate, endDate }, context) => {
  // no dates specified
  if (!startDate || !context?.withNewDateFilter) {
    return '';
  }

  const dateFrom = dateFromFilter(startDate);
  const dateTo = dateToFilter(startDate, endDate);

  return [dateFrom, dateTo].join(' AND ');
};

export default dateTSBuilder;
